import { AxiosAuthRefreshRequestConfig } from "axios-auth-refresh";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import {
  setupPasswordResourcePath,
  setupPasswordResourceType,
} from "@/modules/auth/api/resources/setupPassword/setupPasswordConsts";

export function setupPasswordMutation(jsonApi: JsonApiClient) {
  return (attributes: { token: string; password: string }) =>
    jsonApi.createOne({
      type: setupPasswordResourceType,
      path: setupPasswordResourcePath,
      attributes,
      axiosConfig: {
        skipAuthRefresh: true,
      } as AxiosAuthRefreshRequestConfig,
    });
}
